'use client';

import type { SubsidiaryFilterContextValue } from '@/@subsidiary/types';
import { createContext, useContext } from 'react';

export const SubsidiaryFilterContext = createContext<SubsidiaryFilterContextValue | null>(null);

export function useSubsidiaryFilter() {
    const ctx = useContext(SubsidiaryFilterContext);
    if (!ctx) {
        throw new Error('useSubsidiaryFilter must be used within SubsidiaryFilterProvider');
    }
    return ctx;
}

/** Soft accessor for optional binding (null outside provider). */
export function useSubsidiaryFilterOptional() {
    return useContext(SubsidiaryFilterContext);
}
